import { render } from "./appEventComponent.vue?vue&type=template&id=62a3f71b"
import script from "./appEventComponent.vue?vue&type=script&lang=js"
export * from "./appEventComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__